import React from "react";

export const SEO = ({ title, description }: { title: string; description: string }) => {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="icon" href="/favicon.ico" />
      <meta
        property="og:image"
        content="https://images.prismic.io/showcase-dev/e0df7c68-b31b-4d2f-87c1-39fe3b9e1584_Swapcard_Metadata.png?auto=compress,format"
      />
    </>
  );
};
